import { render } from "./HomeOurStories.vue?vue&type=template&id=4b8628a4&scoped=true&ts=true"
import script from "./HomeOurStories.vue?vue&type=script&lang=ts"
export * from "./HomeOurStories.vue?vue&type=script&lang=ts"

import "./HomeOurStories.vue?vue&type=style&index=0&id=4b8628a4&scoped=true&lang=scss"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8628a4"]])

export default __exports__